import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import FormattedMessage from "@irati/utils/lang"

import {Para} from "../../ui/Labels"
import {getRemainingTeams, getVisibleTeams} from "../../helpers/Survey"
import {IconTooltip} from "../../ui/Tooltip"


const ExpandedPara = styled(Para)`
  white-space: normal;
  margin-bottom: 0;
`

const StyledTooltip = styled(IconTooltip)`
  margin-left: 5px ;
  vertical-align: text-bottom;
`

const NowrapSpan = styled.span`
  white-space: nowrap;
`

const PaddingSpan = styled.span`
  padding-left: 5px;
`

const TeamsRenderer = ({teams, ...props}) => {
  const idNamespace = id("TeamsRenderer", props)
  const visibleTeams = getVisibleTeams(teams)
  const remainingTeams = getRemainingTeams(teams)

  if (!teams.length) {
    return <FormattedMessage id="insights.homepage.teams.all" />
  }

  return (
    <ExpandedPara id={idNamespace}>

      {visibleTeams.map((team) => team.public_name).join(", ")}

      <NowrapSpan>
        {!!remainingTeams.length &&
          <PaddingSpan>
            <FormattedMessage id="insights.homepage.teams.tooltipMoreText" values={{count: remainingTeams.length}} />
          </PaddingSpan>
        }

        {!!remainingTeams.length && (
          <StyledTooltip icon="dotDotDot">
            {remainingTeams.map((team) => team.public_name).join(", ")}
          </StyledTooltip>
        )}
      </NowrapSpan>
    </ExpandedPara>
  )
}

TeamsRenderer.propTypes = {
  teams: PropTypes.array.isRequired
}


export default TeamsRenderer
